import { useEffect, useState } from "react";
import http from "../utils/http";

export default function usePostingItems(postingId) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!postingId) {
      setItems([]);
      return;
    }
    let cancel = false;

    async function fetchData() {
      setLoading(true);
      try {
        const res = await http.get(`/posting-items`, {
          params: {
            "filters[posting][id][$eq]": postingId,
            "sort[0]": "id:asc",
          },
        });
        if (!cancel) {
          setItems(
            res.data.data.map((i) => ({
              id: i.id,
              documentId: i.documentId || i.attributes?.documentId,
              sku: i.sku || i.attributes?.sku,
              offer_id: i.offer_id || i.attributes?.offer_id,
              name: i.name || i.attributes?.name,
              quantity: i.quantity || i.attributes?.quantity,
              kiz_code: i.kiz_code || i.attributes?.kiz_code || "",
              kiz_additional_codes:
                i.kiz_additional_codes || i.attributes?.kiz_additional_codes || [],
              kiz_sent: !!(i.kiz_sent ?? i.attributes?.kiz_sent),
              kiz_returned: !!(i.kiz_returned ?? i.attributes?.kiz_returned),
              withdrawal_status:
                i.withdrawal_status || i.attributes?.withdrawal_status,
              price: i.price || i.attributes?.price,
            })),
          );
        }
      } catch (err) {
        console.error("Ошибка загрузки позиций:", err);
      } finally {
        if (!cancel) setLoading(false);
      }
    }

    fetchData();
    return () => {
      cancel = true;
    };
  }, [postingId]);

  return { items, loading };
}
